export default "__VITE_PUBLIC_ASSET__ab849410__"